import React, { useState } from 'react';

const ExportarArchivo = ({ categorias }) => {
  const [filtroTipo, setFiltroTipo] = useState('');
  const [filtroGrupo, setFiltroGrupo] = useState('');
  const [filtroNombre, setFiltroNombre] = useState('');
  const [descargando, setDescargando] = useState(false);
  const [mensaje, setMensaje] = useState('');

  // Familias de categorías (sin letra final): Minis, Prebenjamín, Benjamín, Alevín, Infantil...
  const familias = [...new Set(
    (categorias || [])
      .map(c => c.nombre.replace(/\s+[A-Z]$/u, '').trim())
      .filter(n => n && !/^x\d?$/i.test(n))
  )];

  const descargar = async () => {
    setDescargando(true);
    setMensaje('');
    try {
      const token = localStorage.getItem('token');
      const params = new URLSearchParams();
      if (filtroTipo) params.append('tipo', filtroTipo);
      if (filtroGrupo) params.append('categoria_id', filtroGrupo);
      if (filtroNombre.trim()) params.append('nombre', filtroNombre.trim());

      const res = await fetch(`/api/exportar/archivo?${params.toString()}`, {
        headers: { 'Authorization': `Bearer ${token}` }
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        setMensaje(err.error || 'Error generando el archivo');
        return;
      }

      const blob = await res.blob();
      const url = URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = `escuela_export_${new Date().toISOString().split('T')[0]}.zip`;
      a.click();
      URL.revokeObjectURL(url);
      setMensaje('✓ Archivo ZIP descargado con datos y fotos');
    } catch (e) {
      setMensaje('Error de conexión al descargar');
    } finally {
      setDescargando(false);
    }
  };

  return (
    <div className="bg-white rounded-lg shadow p-4 sm:p-6 mb-6">
      <h2 className="text-lg font-bold text-gray-900 mb-3">📦 Descargar archivo (datos + fotos)</h2>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 mb-3">
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Categoría</label>
          <select
            value={filtroTipo}
            onChange={(e) => setFiltroTipo(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm bg-white"
          >
            <option value="">Todas</option>
            {familias.map(f => <option key={f} value={f}>{f}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Grupo</label>
          <select
            value={filtroGrupo}
            onChange={(e) => setFiltroGrupo(e.target.value)}
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm bg-white"
          >
            <option value="">Todos</option>
            {(categorias || [])
              .filter(c => !filtroTipo || c.nombre.replace(/\s+[A-Z]$/u, '').trim() === filtroTipo)
              .map(c => <option key={c.id} value={c.id}>{c.nombre}</option>)}
          </select>
        </div>
        <div>
          <label className="block text-xs font-medium text-gray-600 mb-1">Nombre o apellidos</label>
          <input
            type="text"
            value={filtroNombre}
            onChange={(e) => setFiltroNombre(e.target.value)}
            placeholder="Buscar persona..."
            className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm"
          />
        </div>
      </div>

      <button
        onClick={descargar}
        disabled={descargando}
        className="w-full sm:w-auto px-6 py-2.5 bg-indigo-600 hover:bg-indigo-700 disabled:bg-indigo-300 text-white rounded-lg text-sm font-medium"
      >
        {descargando ? 'Generando ZIP...' : '⬇ Descargar ZIP (CSV + fotos)'}
      </button>

      {mensaje && (
        <p className={`mt-2 text-sm ${mensaje.startsWith('✓') ? 'text-green-600' : 'text-red-600'}`}>{mensaje}</p>
      )}
      <p className="text-xs text-gray-500 mt-2">
        El ZIP incluye un CSV con todos los datos y una carpeta por niño (organizadas por grupo) con su foto carnet, DNI por ambas caras y fotos del tutor.
      </p>
    </div>
  );
};

export default ExportarArchivo;
